/* global axios */
import ApiClient from './ApiClient';

class CSATReportsAPI extends ApiClient {
  constructor() {
    super('csat_survey_responses', { accountScoped: true });
  }

  get({
    page,
    from,
    to,
    user_ids,
    inbox_id,
    team_id,
    rating,
    rating_scale,
  } = {}) {
    return axios.get(this.url, {
      params: {
        page,
        since: from,
        until: to,
        sort: '-created_at',
        user_ids,
        inbox_id,
        team_id,
        rating,
        rating_scale,
      },
    });
  }

  download({
    from,
    to,
    user_ids,
    inbox_id,
    team_id,
    rating,
    rating_scale,
  } = {}) {
    return axios.get(`${this.url}/download`, {
      params: {
        since: from,
        until: to,
        // A data de gravação sai no fuso de quem baixa, não em UTC.
        timezone_offset: -new Date().getTimezoneOffset() / 60,
        sort: '-created_at',
        user_ids,
        inbox_id,
        team_id,
        rating,
        rating_scale,
      },
    });
  }

  // Blocos por pergunta: um por pergunta respondida no período. Não recebe
  // `rating` + `rating_scale` ("1-10"): a nota dentro da escala dela.
  getQuestionMetrics({
    from,
    to,
    user_ids,
    inbox_id,
    team_id,
    rating,
    rating_scale,
  } = {}) {
    return axios.get(`${this.url}/question_metrics`, {
      params: {
        since: from,
        until: to,
        user_ids,
        inbox_id,
        team_id,
        rating,
        rating_scale,
      },
    });
  }

  getMetrics({
    from,
    to,
    user_ids,
    inbox_id,
    team_id,
    rating,
    rating_scale,
  } = {}) {
    return axios.get(`${this.url}/metrics`, {
      params: {
        since: from,
        until: to,
        user_ids,
        inbox_id,
        team_id,
        rating,
        rating_scale,
      },
    });
  }
}

export default new CSATReportsAPI();
